"use client";

import React from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Stack,
  Avatar,
  useTheme,
  useMediaQuery,
  Chip,
} from "@mui/material";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import "../app/globals.css";
import { IMAGES } from "../constants/images";

const FeatureComparison = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const features = t("featureComparison.features", { returnObjects: true });

  const restFeatures = [
    true,
    true,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
  ];

  const FeatureIcon = ({ hasFeature, isGetGeek = false }) => {
    if (isGetGeek) {
      return (
        <Box
          sx={{
            width: { xs: 18, sm: 20, md: 23 },
            height: { xs: 18, sm: 20, md: 23 },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Image
            src={IMAGES.TICK_ICON}
            alt="Feature included in best recruiting automation software"
            width={18}
            height={18}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
      );
    }

    return hasFeature ? (
      <Box
        sx={{
          width: { xs: 18, sm: 20, md: 23 },
          height: { xs: 18, sm: 20, md: 23 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Image
          src={IMAGES.TICK_ICON}
          alt="Feature included in best recruiting automation software"
          width={18}
          height={18}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </Box>
    ) : (
      <Box
        sx={{
          width: { xs: 18, sm: 20, md: 23 },
          height: { xs: 18, sm: 20, md: 23 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Image
          src={IMAGES.CROSS_ICON}
          alt="Feature not available in competing automated recruiting software"
          width={18}
          height={18}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </Box>
    );
  };

  return (
    <Box
      sx={{
        backgroundImage: `url('${IMAGES.FEATURE_COMPARISON_BG}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        py: { xs: 3, sm: 4, md: 6, lg: 10 },
        px: { xs: 0, sm: 3, md: 0 },
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="xl" sx={{ position: "relative" }}>
        {/* Header */}
        <Box
          textAlign={{
            xs: isArabic ? "right" : "left",
            sm: "left",
            md: "left",
            lg: "center",
          }}
          mb={{ xs: 3, sm: 4, md: 5, lg: 8 }}
          px={{ xs: 0, sm: 0, md: 1 }}
        >
          <Chip
            label={t("featureComparison.chip")}
            sx={{
              backgroundColor: "white",
              border: "1px solid #0206174D",
              mb: { xs: 1.5, sm: 1.5, md: 2 },
              color: "#818E98",
              fontSize: { xs: "10px", sm: "11px", md: "13px", lg: "15px" },
              fontWeight: "500",
              textTransform: "capitalize",
              px: { xs: 0.4, sm: 0.5, md: 0.6, lg: 0.7 },
              py: { xs: 0.8, sm: 1, md: 1.5, lg: 2.3 },
              fontFamily: "var(--font-outfit)",
              borderRadius: "40px",
            }}
          />
          <Typography
            variant={isMobile ? "h4" : "h3"}
            component="h2"
            sx={{
              color: "#020617",
              fontWeight: 600,
              mb: { xs: 1, sm: 1 },
              lineHeight: 1.3,
              fontSize: {
                xs: "1.2rem",
                sm: "1.4rem",
                md: "1.8rem",
                lg: "2rem",
                xl: "2.5rem",
              },
              fontFamily: "var(--font-plusjakarta)",
              maxWidth: { xs: "100%", lg: 720 },
              mx: { xs: 0, sm: 0, md: 0, lg: "auto" },
            }}
          >
            {t("featureComparison.title1")}
            <span style={{ color: "#9048FB" }}>
              {t("featureComparison.titleHighlight")}
            </span>
            {t("featureComparison.title2")}
          </Typography>
          {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: {
                xs: "flex-start",
                sm: "flex-start",
                md: "flex-start",
                lg: "center",
              },
              gap: 1,
              mt: "1%",
            }}
          >
            <Typography
              sx={{
                fontFamily: "var(--font-plusjakarta)",
                color: "#435562",
                fontSize: {
                  xs: "0.9rem",
                  sm: "1rem",
                  md: "1.2rem",
                  lg: "1rem",
                  xl: "1.5rem",
                },
                fontWeight: "500",
              }}
            >
              {t("featureComparison.dominationLevel")}
            </Typography>
            <Box
              sx={{
                width: { xs: 28, sm: 32, md: 36, lg: 40 },
                height: { xs: 28, sm: 32, md: 36, lg: 40 },
                borderRadius: "50%",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Image
                src={IMAGES.KHABIB_AVATAR}
                alt="Khabib Nurmagomedov"
                width={500}
                height={500}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          </Box> */}
          <Typography
            sx={{
              color: "#02061799",
              mb: 0.7,
              fontWeight: "400",
              fontSize: {
                xs: "13px",
                sm: "14px",
                md: "16px",
                lg: "16px",
                xl: "19px",
              },
              fontFamily: "var(--font-outfit)",
              mx: { xs: 0, sm: 0, md: 0, lg: "auto" },
              textAlign: { xs: "left", sm: "left", md: "left", lg: "center" },
              maxWidth: { xs: "100%", lg: 700 },
              mt: { xs: "3%", sm: "2.5%", md: "2%", lg: "1.5%" },
              lineHeight: 1.5,
            }}
          >
            {t("featureComparison.subtitle")}
          </Typography>
        </Box>

        {/* Comparison Table */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "stretch",
            gap: 0,
            mt: { xs: 2, sm: 4, md: 8, lg: 20 },
            position: "relative",
            maxWidth: { xs: "100%", lg: "1000px" },
            mx: "auto",
          }}
        >
          {/* The Rest Heading - Desktop */}
          <Box
            textAlign="center"
            mb={{ xs: 1.5, sm: 2, md: 2.5, lg: 3 }}
            sx={{
              top: "-16%",
              right: isArabic ? "auto" : "20%",
              left: isArabic ? "20%" : "auto",
              position: "absolute",
              height: { xs: "60px", sm: "70px", md: "90px", lg: "105px" },
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Typography
              sx={{
                fontWeight: 700,
                color: "#6B7280",
                fontSize: {
                  xs: "0.75rem",
                  sm: "0.85rem",
                  md: "1rem",
                  lg: "1.15rem",
                },
                fontFamily: "var(--font-outfit)",
              }}
            >
              {t("featureComparison.theRest")}
            </Typography>
          </Box>

          {/* Features List Card - Left Side */}
          <Card
            sx={{
              width: { xs: "45%", sm: "50%", md: "350px" },
              minWidth: { xs: "140px", sm: "160px" },
              borderRadius: {
                xs: isArabic ? "0 16px 16px 0" : "16px 0 0 16px",
                sm: isArabic ? "0 18px 18px 0" : "18px 0 0 18px",
                md: "24px",
              },
              background: "rgba(255,255,255,0.98)",
              backdropFilter: "blur(10px)",
              display: "flex",
              boxShadow: "none",
              flexDirection: "column",
              pt: { xs: 3.5, md: 0 },
              mr: { xs: 0, sm: 0, md: isArabic ? 0 : -5 },
              ml: { xs: 0, sm: 0, md: isArabic ? -5 : 0 },
            }}
          >
            <CardContent
              sx={{
                p: { xs: 1.5, sm: 2, md: 3, lg: 4 },
                display: "flex",
                flexDirection: "column",
                flex: 1,
              }}
            >
              <Stack spacing={{ xs: 1.5, sm: 1.6, md: 2, lg: 2.3 }}>
                {features.map((feature, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      minHeight: {
                        xs: "28px",
                        sm: "30px",
                        md: "36px",
                        lg: "40px",
                      },
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#3D4E5C",
                        fontWeight: 400,
                        fontSize: {
                          xs: "0.65rem",
                          sm: "0.7rem",
                          md: "0.85rem",
                          lg: "1rem",
                        },
                        fontFamily: "var(--font-outfit)",
                        ml: isArabic ? 0 : { xs: "4%", sm: "3%", md: "3%" },
                        mr: isArabic ? { xs: "4%", sm: "3%", md: "3%" } : 0,
                        textAlign: isArabic ? "right" : "left",
                      }}
                    >
                      {feature}
                    </Typography>
                  </Box>
                ))}
              </Stack>
            </CardContent>
          </Card>

          {/* GetGeek Column - Elevated */}
          <Card
            sx={{
              width: { xs: "27.5%", sm: "25%", md: "240px" },
              minWidth: { xs: "80px", sm: "90px" },
              borderRadius: { xs: "0", md: "24px" },
              background: "#D5ABFF",
              color: "white",
              position: "relative",
              zIndex: 2,
              display: "flex",
              flexDirection: "column",
              mb: { xs: 0, md: -6 },
              mt: { xs: 0, md: -14 },
            }}
          >
            <CardContent
              sx={{
                p: { xs: 1.2, sm: 1.5, md: 2.5, lg: 4 },
                display: "flex",
                flexDirection: "column",
                flex: 1,
              }}
            >
              {/* Header with Logo */}
              <Box
                textAlign="center"
                mb={{ xs: 1.5, sm: 2, md: 2.5, lg: 3 }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Image
                  src={IMAGES.GETGEEK_LOGO_WHITE}
                  alt="Getgeek"
                  width={140}
                  height={37}
                  style={{
                    width: isMobile ? "80px" : "140px",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              </Box>

              {/* Feature Checkmarks */}
              <Stack
                mt={{ xs: 0, md: 6 }}
                spacing={{ xs: 1.5, sm: 1.6, md: 2, lg: 2.3 }}
              >
                {features.map((_, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: {
                        xs: "28px",
                        sm: "30px",
                        md: "36px",
                        lg: "40px",
                      },
                    }}
                  >
                    {index === 9 ? (
                      <Box
                        sx={{
                          width: { xs: 19, sm: 20, md: 40, lg: 24 },
                          minHeight: { xs: 19, sm: 20, md: 40, lg: 25 },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Image
                          src={IMAGES.NUMBER_SEVEN}
                          alt="Seven"
                          width={18}
                          height={18}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </Box>
                    ) : index === 10 ? (
                      <Box
                        sx={{
                          width: { xs: 19, sm: 20, md: 40, lg: 24 },
                          minHeight: { xs: 19, sm: 20, md: 40, lg: 25 },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Image
                          src={IMAGES.NUMBER_NINE_FIVE}
                          alt="9.5"
                          width={18}
                          height={18}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </Box>
                    ) : (
                      <FeatureIcon hasFeature={true} isGetGeek={true} />
                    )}
                  </Box>
                ))}
              </Stack>
            </CardContent>
          </Card>

          {/* The Rest Column */}
          <Card
            sx={{
              width: { xs: "27.5%", sm: "25%", md: "240px" },
              minWidth: { xs: "80px", sm: "90px" },
              borderRadius: {
                xs: isArabic ? "16px 0 0 16px" : "0 16px 16px 0",
                sm: isArabic ? "18px 0 0 18px" : "0 18px 18px 0",
                md: isArabic ? "24px 0 0 24px" : "0 24px 24px 0",
              },
              background: "rgba(255,255,255,0.98)",
              backdropFilter: "blur(10px)",
              borderLeft: isArabic ? undefined : "none",
              borderRight: isArabic ? "none" : undefined,
              boxShadow: "none",
              ml: isArabic ? 0 : { xs: -1.5, sm: -2 },
              mr: isArabic ? { xs: -1.5, sm: -2 } : 0,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              sx={{
                p: { xs: 1.5, sm: 2, md: 2.5, lg: 4 },
                display: "flex",
                flexDirection: "column",
                flex: 1,
              }}
            >
              {/* Header - Mobile only */}
              <Box
                textAlign="center"
                mb={{ xs: 1.5, sm: 2, md: 2.5, lg: 3 }}
                sx={{
                  height: "auto",
                  display: { xs: "flex", md: "none" },
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: "#6B7280",
                    fontSize: {
                      xs: "0.75rem",
                      sm: "0.85rem",
                      md: "1rem",
                      lg: "1.15rem",
                    },
                    fontFamily: "var(--font-outfit)",
                  }}
                >
                  {t("featureComparison.theRest")}
                </Typography>
              </Box>

              {/* Feature Status */}
              <Stack spacing={{ xs: 1.5, sm: 1.6, md: 2, lg: 2.3 }}>
                {restFeatures.map((hasFeature, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: {
                        xs: "28px",
                        sm: "30px",
                        md: "36px",
                        lg: "40px",
                      },
                    }}
                  >
                    {index === 9 ? (
                      <Box
                        sx={{
                          width: { xs: 19, sm: 20, md: 40, lg: 24 },
                          minHeight: { xs: 19, sm: 20, md: 40, lg: 25 },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Image
                          src={IMAGES.NUMBER_FORTY_SEVEN}
                          alt="fourty seven"
                          width={18}
                          height={18}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </Box>
                    ) : index === 10 ? (
                      <Box
                        sx={{
                          width: { xs: 19, sm: 20, md: 40, lg: 24 },
                          minHeight: { xs: 19, sm: 20, md: 40, lg: 25 },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Image
                          src={IMAGES.NUMBER_FIVE}
                          alt="five"
                          width={18}
                          height={18}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </Box>
                    ) : (
                      <FeatureIcon hasFeature={hasFeature} />
                    )}
                  </Box>
                ))}
              </Stack>
            </CardContent>
          </Card>
        </Box>
      </Container>
    </Box>
  );
};

export default FeatureComparison;
